import {DialogTree} from "@/types";

const V2Day2Part3StartingDialog:DialogTree = {
    startDialogId: 'op1',
    nodes: {
        op1: {
            id: 'op1',
            speaker: '',
            text: ``,
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op2",
            sfx : "churchBell"
        },
        op2: {
            id: 'op1',
            speaker: '',
            text: ``,
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op3",
            sfx : "churchOrgan"
        },
        op3: {
            id: 'op1',
            speaker: '',
            text: ``,
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op4",
        },
        op4: {
            id: 'op3',
            speaker: 'Romo Darius',
            text: `Sekali lagi, saya sangat berbelasungkawa`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op5"
        },
        op5: {
            id: 'op3',
            speaker: 'Romo Darius',
            text: `Diana adalah anak baik, semoga dia diterima di sisiNya`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op6"
        },
        op6: {
            id: 'op3',
            speaker: 'Nenek',
            text: `Terima kasih Romo.`,
            characterImage: '/assets/character/v2/nenek.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op7"
        },
        op7: {
            id: 'op3',
            speaker: '',
            text: ``,
            characterImage: '/assets/character/v2/nenek.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId : "op4",
            choices: [
                {
                    text: 'Terima kasih banyak Romo, atas doa-doanya.',
                    nextDialogId: 'op8',
                },
                {
                    text: 'Aku akan mencari kebenaran dibalik semua ini.',
                    nextDialogId: 'op8',
                },
            ],
        },
        op8: {
            id: 'op3',
            speaker: 'Nenek',
            text: `Sudah larut, nenek pulang dulu ya.`,
            characterImage: '/assets/character/v2/nenek.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op9',
        },
        op9: {
            id: 'op9',
            speaker: 'Elsa',
            text: `Yan, kita juga sebaiknya pulang... aku tidak mau disini lagi`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op10',
        },
        op10: {
            id: 'op9',
            speaker: 'Holga',
            text: `Saya setuju, sebaiknya kamu pulang! Tidak usah kembali lagi!`,
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op11',
        },
        op11: {
            id: 'op10',
            speaker: 'Holga',
            text: `Pembawa musibah kamu!`,
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op12',
        },
        op12: {
            id: 'op10',
            speaker: '',
            text: ``,
            choices: [
                {
                    text: 'Cukup, Ato, Holga, Elsa tidak bersalah',
                    nextDialogId: 'op_a1',
                    storyAction: { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
                },
                {
                    text: 'Kita harus mengumpulkan bukti sebelum menuduh orang.',
                    nextDialogId: 'op_a1',
                    //TODO if bunga jelous
                },
                {
                    text: 'Kita harus mengumpulkan bukti sebelum menuduh orang.',
                    nextDialogId: 'op_b1',
                    //TODO if bunga not jelous
                },
            ],
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/gereja.png',
        },
        op_a1: {
            id: 'op_a1',
            speaker: 'Bunga',
            text: `Yan, mereka ada benarnya, mungkin coba pikirkan untuk segera pulang`,
            characterImage: '/assets/character/v2/bunga.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op_a2',
        },
        op_a2: {
            id: 'op_a1',
            speaker: 'Bunga',
            text: `Tempat ini sudah tidak aman.`,
            characterImage: '/assets/character/v2/bunga.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op12',
            isEnd : true
        },
        op_b1: {
            id: 'op_b1',
            speaker: 'Bunga',
            text: `Ato, Holga, pergi lah, tidak hanya kalian yang sedang berduka.`,
            characterImage: '/assets/character/v2/bunga.png',
            backgroundImage: '/assets/backdrop/gereja.png',
            nextDialogId: 'op_a2',
            isEnd : true
        },
    },
}

export default V2Day2Part3StartingDialog